import React from 'react';

import {
  CardsContainer,
  CardWrapper,
  Card,
  CardTitle,
  CardDescription,
  IconContainer,
  CardHoverIconContainer
} from './ServiceTypeCards.styled';
import FertilityDecorativeIcon from 'assets/icons/fertility-decorative.svg?react';
import HolisticHealthDecorativeIcon from 'assets/icons/holistic-health-decorative.svg?react';

import { BookingQuizAnswer } from '../BookingQuiz.types';

interface ServiceTypeCardsProps {
  fertilityAnswer?: BookingQuizAnswer;
  wellnessAnswer?: BookingQuizAnswer;
  onSelect: (answer: BookingQuizAnswer) => void;
}

export const ServiceTypeCards = ({
  fertilityAnswer,
  wellnessAnswer,
  onSelect
}: ServiceTypeCardsProps): React.JSX.Element => {
  return (
    <CardsContainer data-testid="service-options-container">
      {fertilityAnswer && (
        <CardWrapper>
          <Card onClick={() => onSelect(fertilityAnswer)} type="button">
            <IconContainer>
              <FertilityDecorativeIcon />
            </IconContainer>
            <CardHoverIconContainer>
              <FertilityDecorativeIcon />
            </CardHoverIconContainer>
            <CardTitle>{fertilityAnswer.text}</CardTitle>
            <CardDescription>
              Conception, Family-building care, Freezing eggs or embryos
            </CardDescription>
          </Card>
        </CardWrapper>
      )}
      {wellnessAnswer && (
        <CardWrapper>
          <Card onClick={() => onSelect(wellnessAnswer)} type="button">
            <IconContainer>
              <HolisticHealthDecorativeIcon />
            </IconContainer>
            <CardHoverIconContainer>
              <HolisticHealthDecorativeIcon />
            </CardHoverIconContainer>
            <CardTitle>{wellnessAnswer.text}</CardTitle>
            <CardDescription>
              Holistic family care and planning, Pregnancy support, General wellbeing
            </CardDescription>
          </Card>
        </CardWrapper>
      )}
    </CardsContainer>
  );
};
